// ------------- CONTENTS: --------------------------------------------
// - Upsell option layout
// - gpoRenderCompleted
// --------------------------------------------------------------------
// --------------------------------------------------------------------
// ***** Upsell option layout
// --------------------------------------------------------------------
function customiseGloboUpsells() {
    const upsells = document.querySelectorAll('.globo-upsells .gpo-element');

    upsells.forEach((upsell) => {
        const labelText = upsell.querySelector('.gpo-label.expanded .label-content')?.textContent.trim();
        const valueElement = upsell.querySelector('.gpo-ov-wrapper .choicelist-item__value');
        const addOnElement = valueElement?.querySelector('.addOn');

        if (!labelText || !valueElement) {
            return;
        }

        valueElement.childNodes.forEach((node) => {
            if (node.nodeType === Node.TEXT_NODE) {
                node.textContent = labelText;
            }
        });

        if (addOnElement) {
            addOnElement.textContent = addOnElement.textContent.replace(/[()+]/g, '').trim();
        }
    });
}
// --------------------------------------------------------------------
// ***** gpoRenderCompleted
// --------------------------------------------------------------------
document.addEventListener('gpoRenderCompleted', () => {
    const soldOutElement = document.querySelector('.gpo-element:has(input[gpo-data-product-handle]):not(:has(input[gpo-data-product-handle]:not([data-unavailable="true"])))');
    const metaContainer = document.querySelector('.product-single__meta');

    /* Adds Sold Out label to products with sold out globo options */
    if (metaContainer && soldOutElement) {
        metaContainer.classList.add('is-out-of-stock');
    }

    /* Moves upsells below add to cart and add to wishlist */
    const addToCartContainer = document.querySelector('.custom--add-to-cart');
    const upsells = addToCartContainer?.querySelector('.globo-upsells');

    if (addToCartContainer && upsells) {
        addToCartContainer.appendChild(upsells);
    }

    customiseGloboUpsells();
});